@let apartment = apartment$ | async;
@if (apartment) {
  <homey-apartment-detail-page-content
    ngSkipHydration
    [apartment]="apartment"
    [householdSize]="1"
    [showH2]="true"
    [relevantApartmentsInput]="{ type: 'all' }"
  >
    <homey-apartment-detail-info-item
      apartmentUnits
      icon="pi-warehouse"
      [title]="'apartment.units.title' | transloco"
    >
      @if (apartment.type === "regular") {
        <homey-regular-eligible-units [eligibleUnits]="apartment.unitTypes" />
      }
      @else {
        <homey-senior-eligible-units [eligibleUnits]="apartment.unitTypes" />
      }
    </homey-apartment-detail-info-item>

    @switch (apartmentPageStyle()) {
      @case ('eligible-section') {
        <homey-apartment-detail-info-item
          ngSkipHydration
          otherBlocks
          icon="pi-list-check"
          [title]="'apartment.eligibility.title' | transloco"
        >
          <p>
            {{ 'apartment.units.available' | transloco : { count: apartment.unitsAvailable } }}
          </p>
          <p>
            {{ 'apartment.eligibility.checkAndApplyPrefix' | transloco }}
            <a class="text-orange-500 underline font-medium" [routerLink]="initialSignupRoute">Homey</a>
          </p>
        </homey-apartment-detail-info-item>
      }
      @case ('eligible-section-2') {
        <homey-apartment-detail-info-item
          ngSkipHydration
          otherBlocks
          icon="pi-list-check"
          [title]="'apartment.eligibility.wantToKnowTitle' | transloco"
        >
          <p>
            {{ 'apartment.eligibility.checkAndApplyPrefix' | transloco }}
            <a class="text-orange-500 underline font-medium" [routerLink]="initialSignupRoute">Homey</a>
          </p>
        </homey-apartment-detail-info-item>
      }
      @case ('eligible-section-3') {
        <homey-apartment-detail-info-item
          ngSkipHydration
          otherBlocks
          icon="pi-list-check"
          [title]="'apartment.eligibility.wantToKnowTitle' | transloco"
        >
          <p>
            <a class="text-orange-500 underline font-medium" [routerLink]="initialSignupRoute">
              {{ 'apartment.eligibility.checkAndApplyFull' | transloco }}
            </a>
          </p>
        </homey-apartment-detail-info-item>
      }
      @case ('eligible-section-4') {
        <ng-container otherBlocks ngSkipHydration>
          <div>
            <p class="font-medium text-xl mt-2 mb-6 text-center">
              {{ 'apartment.eligibility.wantToKnowTitle' | transloco }}
            </p>
            <div class="flex flex-row justify-center">
              <a pButton [routerLink]="initialSignupRoute" size="small" severity="info">
                {{ 'common.cta.checkEligibility' | transloco }}
              </a>
            </div>
            <p-divider/>
          </div>
        </ng-container>
      }
    }
  </homey-apartment-detail-page-content>

  <homey-lotteries-and-footer [defaultSignupRoute]="initialSignupRoute">
    <ng-container footerTitle>
      {{ 'footer.heroApply.line1' | transloco }}<br />
      <span class="text-orange-gradient">
        {{ 'footer.heroApply.line2' | transloco }}
      </span>
    </ng-container>
  </homey-lotteries-and-footer>
}
